import { render, staticRenderFns } from "./AdviseesCards.vue?vue&type=template&id=07d3107a&"
import script from "./AdviseesCards.vue?vue&type=script&lang=js&"
export * from "./AdviseesCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports